var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInTown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/oversight-services"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M14.4576 15.7393C14.8552 15.7393 15.1776 16.0616 15.1776 16.4593C15.1776 16.8263 14.9029 17.1292 14.5479 17.1736L14.4576 17.1793H1.48953C1.09189 17.1793 0.769531 16.8569 0.769531 16.4593C0.769531 16.0922 1.0442 15.7893 1.39922 15.7449L1.48953 15.7393H14.4576ZM8.44132 0.869372L14.7413 3.92209C15.0517 4.0725 15.2489 4.38708 15.2489 4.73201V6.0792C15.2489 6.57626 14.8459 6.9792 14.3489 6.9792L13.3983 6.9785V13.0391L13.5326 13.0393C13.9303 13.0393 14.2526 13.3616 14.2526 13.7593C14.2526 14.1263 13.978 14.4292 13.6229 14.4736L13.5326 14.4793H2.36547C1.96783 14.4793 1.64547 14.1569 1.64547 13.7593C1.64547 13.3922 1.92014 13.0893 2.27516 13.0449L2.36547 13.0393L2.50833 13.0391V6.9785L1.74887 6.9792C1.25181 6.9792 0.848867 6.57626 0.848867 6.0792V4.73201C0.848867 4.38708 1.046 4.0725 1.35641 3.92209L7.65641 0.869372C7.90427 0.749272 8.19347 0.749272 8.44132 0.869372ZM5.65833 6.9785H3.94833V13.0391H5.65833V6.9785ZM8.80833 6.9785H7.09833V13.0391H8.80833V6.9785ZM11.9583 6.9785H10.2483V13.0391H11.9583V6.9785ZM8.04892 2.2794L2.28892 5.0703V5.5392H13.808V5.0703L8.04892 2.2794Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTown);
export default __webpack_public_path__ + "static/media/InTown.0dac52211ae2f901db68b7c42c871d1a.svg";
export { ForwardRef as ReactComponent };